import { useWithPendingState } from "./use-with-pending-state";
import { pipe } from "fp-ts/function";
import * as E from "fp-ts/lib/Either";
import { CartClientActionResponse } from "../types";

export function useExecutor<Key>() {
  const [updatingKey, withUIPendingState] = useWithPendingState<Key>();

  const executor = <T>(
    key: Key,
    details: Record<string, string>,
    cartModifyingEffect: () => CartClientActionResponse,
  ) => {
    const withPendingState = withUIPendingState({ key, details });

    return withPendingState(() => {
      return cartModifyingEffect().then(response => {
        return pipe(
          response,
          E.foldW(
            errorResponse => {
              const knownErrors = errorResponse.errors.map(error => ({ key, error }));
              return Promise.resolve({ knownErrors, cart: errorResponse.updatedCart });
            },
            cart => {
              return Promise.resolve({ knownErrors: [], cart });
            },
          ),
        );
      });
    });
  };

  return [updatingKey, executor] as const;
}
